import React from 'react';
import { useSelector } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';
import * as api from '../../../api/api';
import * as selectors from '../../../dff/dff-selectors';
import { selectMount } from '../../../dff/dff-slice';
import { useAppDispatch } from '../../../store/store';
import {
  fetchPdfs,
  selectMounts,
  selectPdfs,
  selectSearchText,
  setSearchText,
} from '../../pdf-slice';

require('./files-filter.scss');

export const FilesFilterComponent: React.FC<{}> = () => {
  const mount = useSelector(selectors.mount);
  const dispatch = useAppDispatch();
  const files = useSelector(selectPdfs);
  const mounts = useSelector(selectMounts);
  const searchText = useSelector(selectSearchText);

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const mount = mounts.filter((mount) => mount.id === e.target.value)[0];
    if (!mount) {
      return;
    }

    dispatch(selectMount(mount));

    dispatch(fetchPdfs({ mountId: e.target.value, query: '' }));
  };

  const debounced = useDebouncedCallback((mountId, value) => {
    try {
      dispatch(fetchPdfs({ mountId, query: value }));
    } catch (err) {}
  }, 300);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!files) {
      return;
    }

    const v = e.target.value;
    dispatch(setSearchText(v));
    debounced(mount.id, v);
  };

  const mountName = (mount: api.Mount) => (
    <option value={mount.id} key={mount.id}>
      {mount.name}{' '}
      {mount.type === 'import' ? `(shared by ${mount.owner.name})` : ''}
    </option>
  );

  return (
    <div className="l-files-filter">
      <input
        type="text"
        placeholder="Search for a file"
        onChange={handleInputChange}
        value={searchText}
        className="l-files-filter__input-search"
      />
      <div className="l-files-filter__mount-selector">
        {mounts.length ? (
          <select
            name="mountSelector"
            className="l-files-filter__dropdown"
            value={mount.id}
            onChange={handleSelectChange}
          >
            {mounts.map((mount) => mountName(mount))}
          </select>
        ) : null}
      </div>
    </div>
  );
};
